export default __webpack_public_path__ + "static/media/signInTw.f6ee6bb6.png";